import { NuxtAxiosInstance } from '@nuxtjs/axios'
import BaseRepository from './BaseRepository'

export default class DefaultRepository extends BaseRepository {
  constructor (protected endpoint: string, axios: NuxtAxiosInstance) {
    super(endpoint, axios)
  }
}
